export { default } from './PageEvent.vue'
